module.exports = __webpack_public_path__ + "static/img/fail@2x.afa8b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpesa/fail@2x.png
// module id = uMn9
// module chunks = 1